import {FetchAction, FetchState} from "App/services";
import {ActionType, ApiErrorType} from "App/constants";

export interface SubscribeState {
    error: ApiErrorType
    subscribed: boolean
}

export function subscribeReducer(state: SubscribeState | null = null, action: FetchAction) {
    switch (action.type) {
        case ActionType.START_SUBSCRIBE: {
            return {
                error: ApiErrorType.NONE,
                subscribed: false
            }
        }
        case ActionType.SUBSCRIBE: {
            switch (action.state) {
                case FetchState.SUCCESS: {
                    return {
                        ...state,
                        error: ApiErrorType.NONE,
                        subscribed: true
                    }
                }
                case FetchState.FAILURE: {
                    return {
                        error: action.payload.name,
                        subscribed: false,
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.CANCEL_SUBSCRIBE:
            return null;
        default:
            return state
    }
}

export function startSubscribe(): any {
    return {
        type: ActionType.START_SUBSCRIBE,
    }
}

export function cancelSubscribe(): any {
    return {
        type: ActionType.CANCEL_SUBSCRIBE,
    }
}


// WEBPACK FOOTER //
// ./src/services/reducers/subscribe.ts